module.exports = __webpack_public_path__ + "assets/img/modal-matte-color-with@2x.png";